<div fxFlex fxLayout="column" fxFlexFill>
    <div fxFlex>
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <div fxShow="true" fxHide.lt-md fxFlex fxLayout>
                    <div fxFlex>
                        <span class="mat-h3">{{ "HELICOPTERS.helicopters" | translate }}</span>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
    <div fxFlex class="p-10" style="height: calc(100vh - 135px)">
        <mat-card style="width: 100%; overflow: scroll; max-height: 100%">
            <table mat-table #helicopterTable [dataSource]="dataSource" style="width: 100%">
                <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

                <!-- Position Column -->
                <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.number" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ i + 1 }}
                    </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="operator">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.operator" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ getHelicopterOperator(element.operatorId) }}
                    </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="registrationMark">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.registrationMark" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.registrationMark }}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="serialNumber">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.serialNumber" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.serialNumber }}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.type" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ getHelicopterType(element.helicopterTypeId) }}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="airframeHours">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.airframeHours" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.airFrameTotalHours }}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="engine1Hours">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.engine1Hours" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.engine1TotalHours }}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="engine2Hours">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.engine2Hours" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.engine2TotalHours }}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="firstCalendarType">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.firstCalendarType" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.firstCalendarType }}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="firstCalendarNextDue">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.firstCalendarNextDue" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.firstCalendarNextDue | date: "dd-MM-yyyy" }}
                    </td>
                </ng-container>

                <!-- Remaining Days Column -->
                <ng-container matColumnDef="firstCalendarRemaining">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.firstCalendarRemaining" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.firstCalendarRemaining }}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="firstLimitHourlyType">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.firstLimitHourlyType" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.firstLimitHourlyType }}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="firstLimitHourlyNextDue">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.firstLimitHourlyNextDue" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.firstLimitHourlyNextDue }}
                    </td>
                </ng-container>

                <!-- Remaining Hours Column -->
                <ng-container matColumnDef="firstLimitHourlyRemaining">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.firstLimitHourlyRemaining" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ element.firstLimitHourlyRemaining }}
                    </td>
                </ng-container>

                <!-- Status -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.status" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" [ngStyle]="getStyles(i)">
                        {{ getStatus(element.status) }}
                    </td>
                </ng-container>

                <!-- Document -->
                <ng-container matColumnDef="document">
                    <th mat-header-cell *matHeaderCellDef>{{ "HELICOPTERS.document" | translate }}</th>
                    <td mat-cell *matCellDef="let element; let i = index" style="color: red" [ngStyle]="getStyles(i)">
                        @if (element.docs?.length > 0) {
                            <div style="display: flex; justify-content: end">
                                <a [href]="environment.imageServerUrl + element.docs[0].documentPath" target="_blank" style="margin-top: 4px">{{ element.docs[0].filename }}</a>
                                <mat-icon (click)="openDeleteDialog(element)">delete</mat-icon>
                            </div>
                        }
                        @if (!element.docs || element.docs.length <= 0) {
                            <div>
                                <button mat-button color="primary" (click)="fileInputPDF.click()">Add Document</button>
                                <input hidden #fileInputPDF type="file" id="pdfFile" (change)="handlePDFFileInput($event.target, element.id)" accept=".pdf" />
                            </div>
                        }
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef [hidden]="!isCamo"></th>
                    <td mat-cell *matCellDef="let element; let i = index" style="text-align: right" [hidden]="!isCamo" [ngStyle]="getStyles(i)">
                        <button mat-button color="primary" (click)="openNextScheduleInspectionDialog(element.id)">
                            {{ "HELICOPTERS.nextScheduledInspectionsBtn" | translate }}
                        </button>
                        <!-- <a mat-button color="primary" [routerLink]="['/htl', element.id +'-'+ element.registrationMark,'blocks']">Blocks</a> -->
                    </td>
                </ng-container>

                <!-- Cost Description Column -->
                <ng-container matColumnDef="empty">
                    <th mat-header-cell *matHeaderCellDef colspan="8"></th>
                </ng-container>
                <!-- Cost Description Column -->
                <ng-container matColumnDef="empty-one">
                    <th mat-header-cell *matHeaderCellDef colspan="3"></th>
                </ng-container>
                <!-- Cost Description Column -->
                <ng-container matColumnDef="next-scheduled-inspections">
                    <th mat-header-cell *matHeaderCellDef colspan="6" style="text-align: center">{{ "HELICOPTERS.nextScheduledInspections" | translate }}</th>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['empty', 'next-scheduled-inspections', 'empty-one']" class="example-second-header-row"></tr>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </mat-card>
    </div>
</div>
